import api from "../../../shared/api/client";

export async function getProfiles() {
  const { data } = await api.get("/profile");
  return data;
}

export async function getProfileById(id) {
  const { data } = await api.get(`/profile/${id}`);
  return data;
}

export async function updateProfile(id, body) {
  const { data } = await api.put(`/profile/${id}`, body);
  return data;
}

export async function getStaffList() {
  const { data } = await api.get("/staff");
  return data;
}

export async function getStaffByPersonnelIds(personnelIds) {
  const idsString = Array.isArray(personnelIds)
    ? personnelIds.join(",")
    : personnelIds;

  const { data } = await api.get(`/profile/staff/${idsString}`);
  return data;
}

/** Staff for targeting: direct reports, or all profiles when job_id 77 / superuser. */
export async function getManagedStaff(level = null) {
  const qs =
    level != null && level !== ""
      ? `?level=${encodeURIComponent(level)}`
      : "";
  const { data } = await api.get(`/profile/managed-staff${qs}`);
  return data;
}
